import { useId } from "react";
import { CalcIcon } from "../CalcIcon";
import "./fields.css";

// Energia e desgaste vêm do cadastro da impressora selecionada.
export function TempoSecao({ horas, setHoras, impressoras, impressoraId, selecionarImpressora, impressoraAtual, ocultar = false }) {
  const fieldId = useId();
  const totalMinutos = Math.max(0, Math.round((parseFloat(horas) || 0) * 60));
  const horasParte = Math.floor(totalMinutos / 60);
  const minutosParte = totalMinutos % 60;
  const setHorasMin = (h, m) => {
    const novo = Math.round((Math.max(0, h) + m / 60) * 100) / 100;
    setHoras(novo ? String(novo) : "");
  };

  const energiaHr = impressoraAtual?.consumo_hr != null && impressoraAtual.consumo_hr !== "" ? parseFloat(impressoraAtual.consumo_hr) : null;
  const desgasteHr = impressoraAtual?.desgaste_hr != null && impressoraAtual.desgaste_hr !== "" ? parseFloat(impressoraAtual.desgaste_hr) : null;
  const temEnergia = Number.isFinite(energiaHr);
  const temDesgaste = Number.isFinite(desgasteHr);
  const valorHora = (valor) => valor.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <div className="calc-print-fields">
      <fieldset className="calc-print-time">
        <legend className="calc-field-label"><CalcIcon name="clock" size={16} /> Tempo estimado</legend>
        <div className="calc-print-time-inputs">
          <div className="calc-field-unit">
            <input id={`${fieldId}-horas`} className="calc-field-input" type="number" min="0" step="1" inputMode="numeric"
              value={horas === "" ? "" : horasParte}
              onChange={e => setHorasMin(parseInt(e.target.value, 10) || 0, minutosParte)} placeholder="0" />
            <label htmlFor={`${fieldId}-horas`}>horas</label>
          </div>
          <div className="calc-field-unit">
            <input id={`${fieldId}-minutos`} className="calc-field-input" type="number" min="0" max="59" step="1" inputMode="numeric"
              value={horas === "" ? "" : minutosParte}
              onChange={e => setHorasMin(horasParte, Math.max(0, Math.min(59, parseInt(e.target.value, 10) || 0)))} placeholder="0" />
            <label htmlFor={`${fieldId}-minutos`}>min</label>
          </div>
        </div>
        <p className="calc-field-help">Use o tempo informado pelo fatiador.</p>
      </fieldset>

      <div className="calc-print-printer">
        <label className="calc-field-label" htmlFor={`${fieldId}-impressora`}><CalcIcon name="printer" size={16} /> Impressora</label>
        {impressoras.length > 0 ? (
          <div className="calc-field-select-wrap">
            <select id={`${fieldId}-impressora`} className="calc-field-input calc-field-select" value={impressoraId || ""}
              onChange={e => selecionarImpressora(e.target.value)}>
              <option value="" disabled>Selecione uma impressora</option>
              {impressoras.map(i => <option key={i.id} value={i.id}>{i.nome}</option>)}
            </select>
            <CalcIcon name="chevron" size={16} />
          </div>
        ) : (
          <p className="calc-field-empty">Cadastre uma impressora na aba Impressoras primeiro.</p>
        )}
        {impressoraAtual && (temEnergia || temDesgaste) && (
          <p className="calc-field-help" title="Valores definidos no cadastro da impressora">
            {temEnergia && <>Energia R$ {ocultar ? "••••" : valorHora(energiaHr)}/h</>}
            {temEnergia && temDesgaste && " · "}
            {temDesgaste && <>Desgaste R$ {ocultar ? "••••" : valorHora(desgasteHr)}/h</>}
          </p>
        )}
      </div>
    </div>
  );
}
